import React, { useState, useRef } from 'react';

import { AppWrap, MotionWrap } from '../../wrapper';
import { BsTwitter } from 'react-icons/bs';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import emailjs from '@emailjs/browser';
import './Footer.scss';
import { images } from '../../constants';

const Footer = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const userName = useRef(null);
  const userEmail = useRef(null);
  const userMessage = useRef(null);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .sendForm(
        'service_kaccf9n',
        'template_ieasy6d',
        form.current,
        'MtbbUlOS1mDR682_9',
      )
      .then(
        (result) => {
          setIsSuccess(true);
          userName.current.value = '';
          userEmail.current.value = '';
          userMessage.current.value = '';
        },
        (error) => {
          setIsError(true);
        },
      );
  };
  setTimeout(() => {
    setIsError(false);
    setIsSuccess(false);
    setLoading(false);
  }, 5000);
  return (
    <>
      <h2 className="head-text my-0">
        <span> Got a project </span>that's been waiting? <span> </span>
      </h2>
      <h3 className="subhead-text max-md:text-center my-0">
        Get in Touch, Let's build it
      </h3>

      <form
        className={`app__footer-form  app__flex ${isSuccess ? 'hide' : ''}`}
        ref={form}
        onSubmit={sendEmail}
      >
        <div className="app__flex ">
          <input
            className="p-text text-[16px]"
            type="text"
            placeholder="Enter Your Name"
            name="userName"
            ref={userName}
            required
          />
        </div>
        <div className="app__flex">
          <input
            className="p-text text-[16px]"
            type="email"
            placeholder="Enter Your Email"
            name="userEmail"
            ref={userEmail}
            required
          />
        </div>

        <div>
          <textarea
            className="p-text text-[16px]"
            name="message"
            placeholder="Tell us more about your project here..."
            ref={userMessage}
            required
          />
        </div>
        <button
          type="submit"
          className="btn cta-btn max-md:mx-auto bg-white/10 hover:bg-white/20 font-semibold py-4"
        >
          {loading ? 'Sending . . .' : 'Send Message'}
        </button>
      </form>

      <div>
        {isSuccess && (
          <h3 className="text-2xl h-[40vh] mt-32 capitalize text-center max-w-[50%] mx-auto message text-green-500 font-semibold">
            Thank you for getting in touch, I will get back to you within
            24hours.
          </h3>
        )}
        {isError && (
          <h3 className="text-lg capitalize text-center message text-red-500">
            There is an error in server try after some moment.
          </h3>
        )}
      </div>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <div className="app__social flex">
            <div>
              <a
                href="https://twitter.com/Omesha_Sh"
                rel="noreferrer"
                target={'_blank'}
              >
                <BsTwitter />
              </a>
            </div>
            <div>
              <a
                href="https://github.com/Omeshcoding"
                rel="noreferrer"
                target={'_blank '}
              >
                <BsGithub />
              </a>
            </div>
            <div>
              <a
                href="https://www.linkedin.com/in/umesh-sharma-aa6674131/"
                target={'_blank'}
                rel="noreferrer"
              >
                <BsLinkedin />
              </a>
            </div>
          </div>
        </div>
        <div className="flex max-sm:flex-col   items-center md: mt-14 gap-2 justify-center">
          <div className="flex max-md:flex-col gap-10 md:justify-around">
            {/* <div className="app__footer-card flex items-center">
              <img src={images.mobile} alt="mobile" />
              <a href="tel:+91-937-467-4634" className="p-text">
                +91-937-467-4634
              </a>
            </div> */}
            <div className="app__footer-card flex  items-center max-[400px]:-ml-8 ">
              <img src={images.email} className="grayscale " alt="email" />
              <p className="text-sm mr-4 lg:text-lg  font-semibold leading-9 capitalize">
                Email-
              </p>
              <a
                href="mailto:umesharma78@gmail.com"
                className="p-text hover:text-blue-200"
              >
                umesharma78@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <p className=" text-center text-[.8rem]">
          Developed By Umesh Sharma &copy; {new Date().getFullYear()} <br />
          All right reserved.
        </p>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
